import intl from "../services/intl";

const Text = ({ id, defaultMessage, values }) =>
  intl.t(id, defaultMessage, values);

export default Text;
